import { type LanguageType } from '@models/entities/languages'

export const checkLanguageInLists = (language: LanguageType | string, lists: LanguageType[][]) =>
  lists.every((languageList: LanguageType[]) => languageList.some(languageKey => `${languageKey}` === language))
